// A simple, extendable list of external games for couples.
// Add new entries by appending objects with: id, title, url, image, category, description (optional)

const games = [
  {
    id: 'gartic-phone',
    title: 'Gartic Phone (Play together, free)',
    url: 'https://garticphone.com/',
    image: 'https://images.unsplash.com/photo-1545235617-9465d2a55698?q=80&w=1200&auto=format&fit=crop',
  category: 'Creative',
  description: 'Hilarious drawing + telephone game. Create private rooms and laugh together.'
  },
  {
    id: 'colonist',
    title: 'Coloninst (online Catan)',
    url: 'https://colonist.io',
    image: 'https://unsplash.com/photos/a-close-up-of-a-board-game-on-a-table-fBYtymiEa24',
  category: 'Strategy',
  description: 'Build settlements, trade, and race to victory—Catan, online.'
  },
  {
    id: 'wordle-together',
    title: 'Wordle (Daily Puzzle + Screen Share)',
    url: 'https://www.nytimes.com/games/wordle/index.html',
    image: 'https://images.unsplash.com/photo-1484480974693-6ca0a78fb36b?q=80&w=1200&auto=format&fit=crop',
  category: 'Puzzle',
  description: 'Solve the daily word puzzle together and compare strategies.'
  }
];

export default games;
